/* eslint-disable */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ChatComposer from './chat_composer';
import BeingTackedBy from '../being_tacked_by';
import { TackNotificationDetailsShape } from '../../shapes';
import GuessBadge from './guess_badge';
import YakAiMessage from './yak_ai_message';

const SALUTATIONS = ['Salutations', 'Yo', 'Hello', 'Howdy', 'Good day', 'Hola', 'Greetings', 'Hiya', 'Hi', 'Hey', 'Greetings']

export default class YakChat extends React.Component {
  static propTypes = {
    wordText: PropTypes.string,
    imageUrl: PropTypes.string,
    messages: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    isChatSessionComplete: PropTypes.bool,
    tackNotificationDetails: TackNotificationDetailsShape,
    onSend: PropTypes.func,
    onAddAiMessage: PropTypes.func,
    onResetChat: PropTypes.func,
    onResetUnreadCount: PropTypes.func,
    lastGuessNumber: PropTypes.number,
    accuracyOfLastAttempt: PropTypes.number,
    email: PropTypes.string
  };

  state = {
    lastMessageTypewriterDone: false
  };

  _openingAiMessages() {
    const salutation = SALUTATIONS[Math.floor(Math.random() * SALUTATIONS.length)];
    return [
      `${salutation}! You're on day ${this.props.tackNotificationDetails.get('tackInterval')} of tacking "${this.props.wordText}." Remember what it means? Say it or type the definition in your own words 
       or ask for a hint.`,
    ]
  }

  _onSend = (text) => {
    this.setState({ lastMessageTypewriterDone: false });
    const { onSend } = this.props;
    onSend && onSend(text);
  };

  _onAddAiMessage = (text) => {
    const { onAddAiMessage } = this.props;
    onAddAiMessage && onAddAiMessage(text);
  };

  _onLastMessageTypewriterComplete = () => {
    this.setState({ lastMessageTypewriterDone: true });
  };

  _onResetUnreadCount = () => {
    const { onResetUnreadCount } = this.props;
    onResetUnreadCount && onResetUnreadCount();
    // Navigate to tack board
    window.location.href = '/tack_board';
  };

  componentDidMount() {
    this.props.onResetChat();
    const openingAiMessages = this._openingAiMessages();
    this._onAddAiMessage(openingAiMessages[Math.floor(Math.random() * openingAiMessages.length)]);
  }

  render() {
    const { messages, isLoading, isChatSessionComplete } = this.props;
    return (
      <div>
        <div className='word'>
          <div className='item-meta'>
            <BeingTackedBy tackedBy={this.props.tackNotificationDetails.get('tackedBy')} tacksCount={this.props.tackNotificationDetails.get('tacksCount')} />
          </div>
        </div>
        <ul className='yak-chat' style={{ marginTop: 35 }}>
          {messages.map((message, index) => (
            this.renderMessageRow(message, index)
          ))}
          {!isLoading && !isChatSessionComplete && this.state.lastMessageTypewriterDone &&
            <li key={messages.size} style={{ display: 'flex', alignItems: 'top' }}>
              <span style={{ marginRight: 18 }}>{<GuessBadge email={this.props.email} />}</span>
              <ChatComposer onSend={this._onSend} disabled={isLoading} />
            </li>
          }
        </ul>
        {isChatSessionComplete && this.state.lastMessageTypewriterDone && this.props.accuracyOfLastAttempt > 74 &&
          <div className='action'>
            <button onClick={this._onResetUnreadCount} className='btn btn-dark'>Thanks</button>
          </div>
        }
        {isChatSessionComplete && this.state.lastMessageTypewriterDone && this.props.accuracyOfLastAttempt < 74 &&
          <div className='action'>
            <button onClick={this._onResetUnreadCount} className='btn btn-dark'>Got it</button>
          </div>
        }
      </div>
    );
  }

  renderMessageRow(message, index) {
    const isLastMessage = index === this.props.messages.size - 1;
    return (
      <Fragment key={index}>
        {message.get('userMessage') &&
          <li className='message-item'>
            <GuessBadge email={this.props.email} />
            <div style={{ marginLeft: 18 }}>
              {message.get('userMessage')}             
            </div>
          </li>
        }
        {(message.get('aiResponseMessage') || (this.props.isLoading && isLastMessage)) &&
          <YakAiMessage
            message={message}
            isLast={isLastMessage}
            isChatSessionComplete={this.props.isChatSessionComplete}
            isLoading={this.props.isLoading}
            onTypewriterComplete={isLastMessage ? this._onLastMessageTypewriterComplete : null}
          />}
      </Fragment>
    );
  }
} 


// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/yak_chat.jsx